<div #contextMenu class="button-demo-wrapper action-menu position-relative">
  <button
    type="button"
    (click)="toggle()"
    class="ap-button ap-button-compact ap-button-text bg-transparent">
    <span class="Appkit4-icon icon-vertical-more-outline"></span>
  </button>
  @if (isShow()) {
    <div class="position-absolute bg-white rounded-1 p-2 z-1 context-menu">
      <ul class="p-reset p-0 m-0">
        @for (button of actionMenu; track $index) {
          <li>
            @if (button.showIf ? button.showIf(rowData) : true) {
              <button
                type="button"
                class="ap-button ap-button-text context-menu__btn w-100 rounded-1 text-left"
                ap-tooltip
                direction="top"
                [disabled]="
                  button.disabledIf ? button.disabledIf(rowData) : false
                "
                (click)="button.command(rowData)">
                {{ button.label }}
              </button>
            }
          </li>
        }
      </ul>
    </div>
  }
</div>
